import React from "react";
import { EditAddress } from "./edit-address";
import cIf from 'classnames';
import { Address } from "../../../types/models/mvcapi";

const tr = require('ts-translate-js').default.boundTR;

type AddressPanelProps = {
    address: Address;
    addressType: string;
    allowRemove: boolean;
    addressErrors: any;
    audtoEditMode?: boolean;
    onRemoveAddress: () => void;
    onConfirm: (address: any) => void;
};

export function SingleAddress({address, addressType, allowRemove, addressErrors, audtoEditMode = false, onRemoveAddress, onConfirm} : AddressPanelProps) {
    const [showEditingPanel, setShowEditingPanel] = React.useState(audtoEditMode);

    const hasErrors = addressErrors && addressErrors.length > 0;

    const handleEditAddress = () => {
        setShowEditingPanel(true);
    };

    const handleOnConfirm = (editedAddress) => {
        if(!audtoEditMode) 
            setShowEditingPanel(false);
        onConfirm(editedAddress);
    };

    return (showEditingPanel ?
        <EditAddress 
            address={address} 
            addressType={addressType}
            addressErrors={addressErrors}
            audtoEditMode={audtoEditMode}
            onConfirm={handleOnConfirm} 
            onCancel={() => setShowEditingPanel(false)} 
        /> :
        <div key={address.ID} className="address">
            <h4>{addressType}</h4>
            <div className={cIf({"well": true, "field-error": hasErrors})}>
                <div className="col-sm-12">
                    <address>
                        <div>{address.ClientName}</div>
                        <div>{address.Address1}</div>
                        <div>{address.Address2}</div>
                        <div>{address.City}</div>
                        <div>{address.Province + ", " + address.Country}</div>
                        <div>{address.PostalCode}</div>
                    </address>
                </div>
                <div className="btn-toolbar">
                    {allowRemove &&
                    <button className="btn btn-default" type="button" onClick={onRemoveAddress}>
                        <span className="glyphicon glyphicon-trash"></span> {tr("shippingaddresspanel.remove")}
                    </button>}
                    <button className="btn btn-primary" type="button" onClick={handleEditAddress}>
                        <span className="glyphicon glyphicon-pencil"></span> {tr("shippingaddresspanel.edit")}
                    </button>
                </div>
            </div>
        </div>
    );
}